import { ChatItemTaskContainerProps } from './chatTaskProps';
import { ChatItemTaskController, ChatItemTaskLoader } from './chatTaskInterface';
import { ReportingShellContainerBaseConfig } from '../../../../base';

export function createChatItemTaskContainer(
    config: ReportingShellContainerBaseConfig & {
        navigation: {
            task(props: { task: string }): {
                path: string;
            };
        };
    },
    loader: ChatItemTaskLoader,
    controller: ChatItemTaskController
): React.FC<ChatItemTaskContainerProps> {
    const {
        repository: { research: repository },
        context: { useContext },
        pubsub: { router: pubsub },
    } = config;

    return ({ as: View, item, ...containerProps }) => {
        const context = useContext();
        const data = loader.useLoad(context, { item });
        const props = controller.useProps(context, data, {
            task: {
                path: data.task
                    ? config.navigation.task({ task: data.task.id }).path
                    : null,
            },
        });
        return <View {...props} />;
    };
}
